<template>
  <div>
    <v-data-table
      v-model="itensSelecionados"
      :headers="headers"
      :items="itens_filtrados"
      fixed-header
      height="calc(100vh - 255px)"
      class="table-full-screen"
      show-select
      :items-per-page="-1"
    >
      <template v-slot:top>
        <div class="d-flex py-2 pl-3">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          <p class="ma-0 subtitle-1 font-weight-medium pt-1">
            Tempo de Cobertura por Curva de Popularidade
          </p>

          <v-spacer />

          <template v-if="itensSelecionados.length > 0">
            <v-badge color="white" overlap class="mr-6">
              <template v-slot:badge>
                <span style="color: #000">{{ itensSelecionados.length }}</span>
              </template>

              <v-btn color="error" @click="confirmarDelecao()">
                <v-icon left>mdi-delete</v-icon>
                Excluir
              </v-btn>
            </v-badge>

            <v-badge color="white" overlap class="mr-6">
              <template v-slot:badge>
                <span style="color: #000">{{ itensSelecionados.length }}</span>
              </template>

              <v-btn color="success" @click="confirmarAplicacaoDeCobertura()">
                <v-icon left>mdi-send-clock</v-icon>
                Aplicar coberturas
              </v-btn>
            </v-badge>
          </template>

          <template v-else>
            <div style="width: 250px">
              <v-autocomplete
                v-model="filtros.grupo.valor"
                :items="filtros.grupo.itens"
                label="Filtro de grupo"
                item-value="grupo"
                item-text="nome_grupo"
                hide-details
                dense
                outlined
                class="mr-4"
                clearable
                @change="filtros.filial.valor = []"
              />
            </div>

            <div style="width: 300px">
              <v-autocomplete
                v-model="filtros.filial.valor"
                :items="filtros.filial.itens"
                label="Filtro de filial"
                item-value="filial"
                item-text="descricao_filial"
                hide-details
                multiple
                dense
                outlined
                clearable
                class="mr-4"
              >
                <template #prepend-item>
                  <SysItemListaSelecionaTudo
                    v-model="filtros.filial.valor"
                    :itens="filtros.filial.itens"
                    valor-chave="filial"
                    class="pl-2" />
                  <v-divider />
                </template>

                <template #selection="{item}">
                  {{item.filial}}<template v-if="filtros.filial.valor.indexOf(item.filial) !== filtros.filial.valor.length - 1">,&nbsp;</template>
                </template>
              </v-autocomplete>
            </div>
          </template>

          <v-btn class="primary" @click="dialogCadastro = ! dialogCadastro">
            <v-icon left>mdi-plus</v-icon>
            Novo
          </v-btn>

          <dialog-cadastro
            v-model="dialogCadastro"
            :itemParaEdicao="editedItem"
            @atualizar-lista="buscarItems()"
          ></dialog-cadastro>
        </div>
      </template>

      <template #item.data-table-select="{item}">
        <v-btn v-if="!itensSelecionados.includes(item)" icon @click="itensSelecionados.push(item)">
          <v-icon>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <v-btn v-else icon @click="itensSelecionados = itensSelecionados.filter(sel => sel !== item)">
          <v-icon>mdi-checkbox-marked</v-icon>
        </v-btn>
      </template>

      <template v-slot:header.action="{item}">
        <div class="text-center">Ações</div>
      </template>

      <template v-slot:item.pqr="{value}">
        {{ descricaoDeApelidosCurvas.descricao_pqr[(value || '').toLowerCase()] }}
      </template>

      <template #item.xyz="{ value }">
        {{ descricaoDeApelidosCurvas.descricao_xyz[(value || '').toLowerCase()] }}
      </template>

      <template v-slot:item.tempo_cobertura="{item}">
        <div class="text-center ml-n15">
          {{ Helpers.formatarValor(item.tempo_cobertura) }}
        </div>
      </template>

      <template #item.aplicado="{item}">
        {{!item.aplicado ? 'não aplicado' : item.aplicado}}
      </template>

      <template v-slot:item.action="{item, select}">
        <v-tooltip top open-delay="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="itensSelecionados = [item];confirmarAplicacaoDeCobertura()">
              <v-icon>mdi-send-clock</v-icon>
            </v-btn>
          </template>
          <span>Aplicar Tempo de Cobertura aos produtos correspondentes.</span>
        </v-tooltip>

        <v-tooltip top open-delay="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="editarItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edição de Item.</span>
        </v-tooltip>

        <v-tooltip top open-delay="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="itensSelecionados = [item];confirmarDelecao()">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Exclusão de item.</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <DialogConfirmacao v-model="dialogConfirmacaoAplicar" color="success" @confirmado="aplicarTempoDeCobertura()">
      <template #body>
        <p v-text="'Deseja realmente aplicar Tempo de Cobertura selecionados?'" />
      </template>
    </DialogConfirmacao>

    <DialogConfirmacao
      v-model="dialogConfirmacaoExclusao"
      color="red"
      @confirmado="deleteItem()"
    >
      <template #body>
        <p v-text="'Deseja realmente excluir os itens selecionados?'" />
      </template>
    </DialogConfirmacao>
  </div>
</template>

<script>
import DialogCadastro from './DialogCadastro'
import TempoCoberturaAPI from '../../../api/drp/TempoCoberturaPorPopularidade'
import DialogConfirmacao from '../../utils/DialogConfirmacao'
import SysItemListaSelecionaTudo from "../../utils/crud/SysItemListaSelecionaTudo";
import * as descricaoDeApelidosCurvas from "@/components/Diagnostico/CurvasCruzadas/ParametrizacaoDeCoberturas/CoberturasCurvasPadrao";

export default {
  name: 'CurvasPopularidadeTabela',
  components: {SysItemListaSelecionaTudo, DialogConfirmacao, DialogCadastro},
  data: () => ({
    headers: [
      { text: '#Id', value: 'id' },
      { text: 'Grupo', value: 'nome_grupo' },
      { text: 'Filial', value: 'filial' },
      { text: 'Curva Frequência', value: 'pqr' },
      { text: 'Curva Faturamento', value: 'xyz' },
      { text: 'Tempo de Cobertura', value: 'tempo_cobertura_drp', width: '180px' },
      { text: 'Usuário (última alteração)', value: 'usuario_log' },
      { text: 'Aplicado em', value: 'aplicado' },
      { text: 'Ações', value: 'action', width: '130px' }
    ],
    items: [],
    itensSelecionados: [],
    dialogConfirmacaoExclusao: false,
    dialogConfirmacaoAplicar: false,
    dialogCadastro: false,
    editedItem: {},
    filtros: {
      grupo: {
        valor: "",
        itens: []
      },
      filial: {
        valor: [],
        itens: []
      },
    },
    descricaoDeApelidosCurvas: descricaoDeApelidosCurvas,
  }),
  computed: {
    itens_filtrados_por_grupo() {
      if (!(this.filtros.grupo.valor > 0)) {
        return this.items;
      }

      return this.items.filter(item => this.filtros.grupo.valor == item.grupo)
    },
    itens_filtrados() {
      if (this.filtros.filial.valor.length > 0) {
        return this.itens_filtrados_por_grupo.filter(item => this.filtros.filial.valor.includes(item.filial))
      }

      return this.itens_filtrados_por_grupo;
    }
  },
  watch: {
    dialogCadastro (dialog) {
      !dialog && (this.itensSelecionados = [])
    },
    dialogConfirmacaoExclusao (dialog) {
      !dialog && (this.itensSelecionados = [])
    },
    dialogConfirmacaoAplicar (dialog) {
      !dialog && (this.itensSelecionados = [])
    },
    items() {
      this.filtros.grupo.itens = [];

      this.items.forEach(item => {
        const item_grupo = {grupo: item.grupo, nome_grupo: item.nome_grupo};

        if (!this.filtros.grupo.itens.includes(item_grupo)) {
          this.filtros.grupo.itens.push(item_grupo);
        }
      })
    },
    itens_filtrados_por_grupo(itens) {
      this.filtros.filial.itens = [];

      itens.forEach(item => {
        if (!this.filtros.filial.itens.some(filial => item.filial === filial.filial)) {
          const item_filial = {filial: item.filial, descricao_filial: `Filial ${item.filial}`};
          this.filtros.filial.itens.push(item_filial);
        }
      })
    }
  },
  created() {
    this.buscarItems()
  },
  methods: {
    editarItem (item) {
      this.dialogCadastro = true
      this.editedItem = Object.assign({}, item)
    },
    buscarItems () {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaAPI.getListaFull(headers)
          .then((response) => {
            const {token, itens} = response.data;
            localStorage.token = token
            this.items = itens
          })
          .catch(() => this.Helpers.logout())
      );
    },
    confirmarDelecao () {
      this.dialogConfirmacaoExclusao = true
    },
    deleteItem () {
      const headers = this.Helpers.iniciarRequisicao();
      const ids = this.Helpers.arrayColumn(this.itensSelecionados, 'id')

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaAPI.deleteMultiplos(headers, { ids })
          .then((response) => {
            const {token} = response.data;
            localStorage.token = token
            this.buscarItems()
          })
          .catch(() => this.Helpers.logout())
      );
    },
    confirmarAplicacaoDeCobertura () {
      this.dialogConfirmacaoAplicar = true
    },
    aplicarTempoDeCobertura () {
      const ids = this.Helpers.arrayColumn(this.itensSelecionados, 'id')

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaAPI.aplicarTempoCobertura({ids})
          .then((response) => {
            const {token} = response.data;
            localStorage.token = token;
            this.buscarItems();
          })
          .catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style scoped>

</style>
